<template>
  <DataTable
    :default-headers="['serviceName', 'serviceDesc']"
    :data-set="rows"
    body-cell-class="align-baseline"
  >
    <template #cell="{ columnName, columnValue, rowIndex }">
      <span class="text-xs text-brand-black-secondary">{{ columnValue }}</span>
    </template>
  </DataTable>
</template>

<script setup>
import DataTable from '@/components/DataTable/index.vue'
import { useI18n } from 'vue-i18n'
const i18n = useI18n()

const rowsTotal = 11
const rows = []
for (let index = 0; index < rowsTotal; index++) {
  rows.push({
    serviceName: i18n.t(`serviceName${index + 1}`),
    serviceDesc: i18n.t(`serviceDesc${index + 1}`)
  })
}
</script>

<style lang="scss" scoped></style>
